import { BreadcrumbsState } from './state';

export const SET_BREADCRUMBS = 'SET_BREADCRUMBS';
export const DEL_BREADCRUMBS = 'DEL_BREADCRUMBS';

interface SetBreadcrumbs {
    type: typeof SET_BREADCRUMBS;
    payload: BreadcrumbsState;
}

interface DeleteBreadcrumbs {
    type: typeof DEL_BREADCRUMBS;
}

export type BreadcrumbsAction = SetBreadcrumbs | DeleteBreadcrumbs;
